module.exports = __webpack_public_path__ + "static/media/yellow-t.cc81dea7.svg";